module.exports = __webpack_public_path__ + "static/img/2Cguidance8equV6Ja1v1AzPWfH22cl4G9kO0.84cdc5d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/originalframerhtml_files/2Cguidance8equV6Ja1v1AzPWfH22cl4G9kO0.jpg
// module id = Avfs
// module chunks = 73